export const primary = {
  '50': 'rgb(255, 246, 253)',
  '100': 'rgb(255, 238, 249)',
  '150': 'rgb(254, 230, 246)',
  '200': 'rgb(253, 222, 242)',
  '250': 'rgb(251, 212, 239)',
  '300': 'rgb(249, 201, 235)',
  '350': 'rgb(247, 191, 233)',
  '400': 'rgb(244, 181, 230)',
  '450': 'rgb(239, 150, 218)',
  '500': 'rgb(233, 117, 204)',
  '550': 'rgb(225, 80, 190)',
  '600': 'rgb(217, 18, 174)',
  '650': 'rgb(187, 12, 148)',
  '700': 'rgb(157, 6, 123)',
  '750': 'rgb(129, 2, 100)',
  '800': 'rgb(101, 0, 77)',
  '850': 'rgb(77, 0, 58)',
  '900': 'rgb(55, 0, 40)',
  '950': 'rgb(34, 0, 23)',
}
export const accent = {
  '50': 'rgb(240, 251, 255)',
  '100': 'rgb(228, 246, 255)',
  '150': 'rgb(215, 242, 254)',
  '200': 'rgb(203, 237, 253)',
  '250': 'rgb(188, 234, 254)',
  '300': 'rgb(173, 231, 255)',
  '350': 'rgb(157, 227, 255)',
  '400': 'rgb(140, 224, 255)',
  '450': 'rgb(90, 201, 255)',
  '500': 'rgb(38, 174, 255)',
  '550': 'rgb(0, 143, 255)',
  '600': 'rgb(20, 108, 253)',
  '650': 'rgb(12, 90, 212)',
  '700': 'rgb(5, 72, 173)',
  '750': 'rgb(2, 54, 136)',
  '800': 'rgb(0, 38, 100)',
  '850': 'rgb(0, 26, 77)',
  '900': 'rgb(0, 16, 55)',
  '950': 'rgb(0, 6, 34)',
}
export const grey = {
  '50': 'rgb(250, 250, 250)',
  '100': 'rgb(245, 245, 245)',
  '150': 'rgb(240, 240, 240)',
  '200': 'rgb(235, 235, 235)',
  '250': 'rgb(227, 229, 230)',
  '300': 'rgb(220, 223, 224)',
  '350': 'rgb(212, 217, 219)',
  '400': 'rgb(205, 211, 214)',
  '450': 'rgb(170, 176, 180)',
  '500': 'rgb(136, 143, 146)',
  '550': 'rgb(104, 111, 114)',
  '600': 'rgb(73, 80, 84)',
  '650': 'rgb(63, 69, 73)',
  '700': 'rgb(53, 59, 63)',
  '750': 'rgb(43, 49, 53)',
  '800': 'rgb(34, 39, 43)',
  '850': 'rgb(24, 28, 31)',
  '900': 'rgb(14, 17, 19)',
  '950': 'rgb(5, 7, 9)',
}
